// extracted by mini-css-extract-plugin
module.exports = {"productPage":"product_productPage__OKRs0"};